// extracted by mini-css-extract-plugin
export var banner = "_2w-0";
export var icon = "_2w-1";
export var message = "_2w-2";